// ─── Lists and promotion, not news ───────────────────────────────────────────
//
// Sprint 14, 2.1 (David, 06/10/2026). Zacks, Motley Fool and the like put out
// pieces that are about a stock without being news about it: a dividend sum
// ("Here's How Many Shares of Apple You'd Need for $10,000 in Annual
// Dividends"), a house newsletter ("Zacks Investment Ideas feature
// highlights …"), a list of picks. They name a holding, so the matcher ties
// them to the portfolio, and they reach "נוגע לתיק שלי", the home screen and
// "מה השתנה" as if something had happened to the company.
//
// A headline matching this list is never tied to a holding. It is handled
// exactly like an advice-worded headline (constants/advisory.js ·
// isAdvisoryArticle checks both lists), so every place that keeps advice away
// from the portfolio keeps this away too. In the general feed it stays an
// ordinary card, and never the lead story.
//
// To add or remove a pattern, edit the list below · nothing else changes.
// English, word boundaries, case-insensitive, matched on the headline only:
// a summary that mentions dividend income is not a list.
export const NOISE_EN = [
  "here'?s how many shares",
  "how many shares\\b.{0,80}?\\bto (?:earn|make|generate|get|collect|receive)",
  "stocks? to buy(?![-\\s]?side)",
  "investment ideas",
  // "highlights from" alone also catches news ("Key highlights from Nvidia's
  // earnings call", "Fed minutes: highlights from the September meeting"),
  // so only a house show or newsletter, or Zacks' "feature highlights".
  "highlights from (?:the )?(?:motley fool|fool|zacks|investor'?s business daily)",
  "feature highlights",
  "top picks?",
  "should you buy",
  // A dividend sum to build, not a company's dividend income reported.
  "(?:build|boost|grow|generate|earn|collect|passive|annual|monthly|reliable|for) dividend income",
  "zacks investment ideas",
  "bull of the day",
  "bear of the day",
  "passive income",
  "millionaire[- ]maker",
];

// Typographic apostrophes (’) are read as plain ones, so "Here’s" matches.
export const NOISE_RE = new RegExp(`\\b(?:${NOISE_EN.join("|")})\\b`, "i");
const plain = t => t.replace(/[‘’ʼ]/g, "'");

/** True when a headline is a list or a promotion rather than news. */
export function isNoiseHeadline(title) {
  return typeof title === "string" && !!title && NOISE_RE.test(plain(title));
}
